import type { IGetResolvedTestIdParams } from "./types";

export const getResolvedTestId = ({
  testIdPrefix,
  suffix,
}: IGetResolvedTestIdParams): string | undefined => {
  return testIdPrefix ? `${testIdPrefix}-${suffix}` : undefined;
};
